// extracted by mini-css-extract-plugin
export default {"label":"G7f47c5 G519ebe"};